// Shared row for an archived / deleted quote with Restore.
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, RotateCcw } from "lucide-react";
import api from "../../lib/api";

const gbp = (v) => (v == null ? "—" : `£${Number(v).toLocaleString("en-GB", { maximumFractionDigits: 0 })}`);
const d = (v) => (v ? new Date(v).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export default function OldQuoteRow({ r, onRestored, showCustomer = true }) {
  const [busy, setBusy] = useState(false);
  const restore = async () => {
    setBusy(true);
    try { await api.post(`/quote-bin/${r._id}/restore`); toast.success(`${r.QuoteRef || "Quote"} restored`); onRestored?.(r); }
    catch (e) { toast.error(e?.response?.data?.detail || "Restore failed"); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-start gap-3 px-3 py-2.5 border-b border-white/[0.05]" data-testid={`old-quote-${r.QuoteRef || r._id}`}>
      <span className={`mt-0.5 shrink-0 px-1.5 py-0.5 rounded text-[9.5px] font-mono uppercase ${r.where === "deleted" ? "bg-rose-500/15 text-rose-200" : "bg-slate-500/20 text-slate-200"}`}>{r.where}</span>
      <div className="min-w-0 flex-1">
        <div className="text-[12.5px] text-white">
          {r.where === "archived" ? <Link to={`/quotes/${r._id}/edit`} className="font-mono font-semibold hover:underline">{r.QuoteRef || "No ref"}</Link> : <span className="font-mono font-semibold">{r.QuoteRef || "No ref"}</span>}
          {showCustomer && <span className="text-slate-300"> · {r.customer}{r.company ? ` (${r.company})` : ""}</span>}
          <span className="text-slate-400"> · {gbp(r.total)} · {r.lines} line{r.lines === 1 ? "" : "s"} · owner {r.owner || "—"}</span>
        </div>
        <div className="text-[11px] text-slate-500">{r.where === "deleted" ? "Deleted" : "Archived"} {d(r.removed_at)} by {r.removed_by || "—"} · {r.reason}</div>
      </div>
      <button type="button" onClick={restore} disabled={busy} data-testid={`old-quote-restore-${r.QuoteRef || r._id}`}
        className="shrink-0 inline-flex items-center gap-1 h-7 px-2.5 rounded-md border border-teal-500/40 bg-teal-500/10 text-[11px] font-semibold text-teal-200 hover:bg-teal-500/20 disabled:opacity-50">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <RotateCcw className="w-3 h-3" />} Restore</button>
    </div>
  );
}
